var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"map",staticStyle:{"width":"100%","height":"420px","border-radius":"10px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }